import type { ApiErrorMessage } from 'epic/apiErrorEpicHelper';
import type { WorkspaceType } from 'state/workspaces/model';

export type BookingActions = BookingRequested | BookingAcked | BookingAckFailed | BookingFailed;

export function bookingRequested(
  tabId: string,
  formId: string,
  quoteId: string,
  frontReconciliationId: string,
  workspace: WorkspaceType,
) {
  return {
    type: 'BOOKING_REQUESTED' as const,
    tabId,
    formId,
    quoteId,
    frontReconciliationId,
    workspace,
  };
}
export type BookingRequested = ReturnType<typeof bookingRequested>;

export function bookingAcked(
  tabId: string,
  formId: string,
  quoteId: string,
  frontReconciliationId: string,
  workspace: WorkspaceType,
  newVersion?: number,
) {
  return {
    type: 'BOOKING_ACKED' as const,
    tabId,
    formId,
    quoteId,
    frontReconciliationId,
    workspace,
    newVersion,
  };
}
export type BookingAcked = ReturnType<typeof bookingAcked>;

export function bookingAckFailed(tabId: string, formId: string, error: ApiErrorMessage, workspace: WorkspaceType) {
  return {
    type: 'BOOKING_ACK_FAILED' as const,
    tabId,
    formId,
    error,
    workspace,
  };
}
export type BookingAckFailed = ReturnType<typeof bookingAckFailed>;

export function bookingFailed(formId: string, error: ApiErrorMessage, workspace: WorkspaceType) {
  return {
    type: 'BOOKING_FAILED' as const,
    formId,
    error,
    workspace,
  };
}
export type BookingFailed = ReturnType<typeof bookingFailed>;
